import React from 'react';
import './SelectableCardButton.css';


const SelectableCardButton = ({ icon, label, onClick, selected, disabled }) => {
    return (
        <button
            className={`selectable-card-button ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
        >
            <span className="icon">{icon}</span>
            <span className="label">{label}</span>
        </button>
    );
};

export default SelectableCardButton;